import { memo } from "react"

function DocumentFilePreview({ fileType, url }) {
    return <div style={{ border: "2px solid" }} className="w-[380px] rounded-lg flex items-center justify-center !border-white">
        {fileType === "video" ? <video className="!w-[380px]" controls src={url}></video> : <img src={url} className="w-[380px]" alt="" />}
    </div>
}

export default memo(DocumentFilePreview)